const getOktaAuthConfig = (oktaUrl: string | null): any => {
  const oktaAuthConfig = {
    issuer: `https://${oktaUrl}/oauth2/default`,
    redirectUri: window.location.origin + '/login/callback',
    responseType: ['id_token', 'token'],
    pkce: false
  };

  return oktaAuthConfig;
};
const getOktaSignInConfig = (oktaUrl: string | null): any => {
  const oktaSignInConfig = {
    baseUrl: `https://${oktaUrl}`,
    redirectUri: window.location.origin + '/login/callback',
    logo: '/ascential-connect-logo.png',
    authParams: {
      issuer: `https://${oktaUrl}`,
      responseType: ['id_token', 'token'],
      scopes: ['openid', 'profile', 'email'],
      pkce: false
    }
  };

  return oktaSignInConfig;
};

export { getOktaAuthConfig, getOktaSignInConfig };
